// extracted by mini-css-extract-plugin
export default {"layout":"CarouselSkeleton_layout__MRq3v"};